import React, { useRef } from 'react'
import styles from './style.css'
import ReactModal from 'react-modal'
import Audio from '../../lib/audio'

const ImgVideoModal = ({ onClose, type, url }) => {
    const videoRef = useRef()
    const coverRef = useRef()
    const handleVideoClick = () => {
        if (!videoRef) return
        if (videoRef.current.paused) {
            if (videoRef.current.innerHTML.trim() == '') {
                videoRef.current.innerHTML = `<source src='${url}' type='video/mp4'/>`
            }
            coverRef.current.hidden = true
            Audio.stop()
            videoRef.current.play()
        } else {
            coverRef.current.hidden = false
            videoRef.current.pause()
        }
    }

    return (
        <ReactModal
            overlayClassName={styles.ReactModal__Overlay}
            className={styles.ReactModal__Content}
            isOpen={true}
            closeTimeoutMS={400}
        >
            <div className={styles.modalContainer}>
                <div className={styles.header}>
                    <div className={styles.titleBlock} onClick={onClose}>
                        <p>×</p>
                        <p>关闭</p>
                    </div>
                </div>
                {
                    type === 'img' ? (
                        <div className={styles.videoArea}>
                            <img src={url} />
                        </div>
                    ) : (
                        <div className={styles.videoArea}>
                            <div
                                className={styles.videoCover}
                                ref={coverRef}
                                onClick={handleVideoClick}
                            ></div>
                            <video
                                ref={videoRef}
                                webkit-playsinline='true'
                                style={{ width: '100%' }}
                                onClick={handleVideoClick}
                            >
                            </video>
                        </div>
                    )
                }
            </div>
        </ReactModal>
    )
}

export default ImgVideoModal
